import { Checkbox, Collapse, Divider } from "@mui/material";
import ChevronIcon from "assets/icons/ChevronIcon";
import { useEffect, useState } from "react";
import PrePay from "./prepay";
import ProfitCalculation from "./profit";
import LatencyPenalty from "./penalty";
import Guarantee from "./guarantee";
import CrossIcon from "assets/icons/CrossIcon";
import { useFormikContext } from "formik";

export default function Settings() {
  const data = useFormikContext<InstallmentData>();
  const [appear, setAppear] = useState(true);
  const [active, setActive] = useState<number[]>([]);

  useEffect(() => {
    if (data.values.activeSettings) {
      setActive(data.values.activeSettings);
    }

    return () => {};
  }, []);

  const settings = [
    {
      label: "پیش پرداخت",
      comp: PrePay,
      value: "prePay",
    },
    {
      label: "محاسبه سود",
      comp: ProfitCalculation,
      value: "profitCalculation",
    },
    {
      label: "جریمه دیر کرد",
      comp: LatencyPenalty,
      value: "latencyPenalty",
    },
    // {
    //   label: "ضمانت نامه",
    //   comp: Guarantee,
    //   value: "guarantee",
    // },
  ];

  const resetUncheckValue = (value: string, isActive: boolean) => {
    if (value === "prePay" && !isActive) {
      data.setFieldValue("prePay", 0);
      data.setFieldValue("prePayType", "percent");
      data.setFieldValue("prePaySourceId", undefined);
      data.setFieldValue("prePaySourceType", "bank");
    }
    if (value === "profitCalculation" && !isActive) {
      data.setFieldValue("profitRateType", "percent");
      data.setFieldValue("totalProfit", 0);
      data.setFieldValue("profitRate", 0);
    }
    if (value === "latencyPenalty" && !isActive) {
      data.setFieldValue("penaltyGapType", "month");
      data.setFieldValue("penaltyGap", "");
      data.setFieldValue("penaltyRate", "");
      data.setFieldValue("penaltyRateType", "percent");
    }
    if (value === "guarantee" && !isActive) {
      data.setFieldValue("guarantees", []);
    }
  };

  const handleClick = (value: number, isActive: boolean) => {
    const updatedActiveSettings = isActive
      ? (data.values.activeSettings ?? []).filter((setting) => setting !== value)
      : [...(data.values.activeSettings ?? []), value];

    data.setFieldValue("activeSettings", updatedActiveSettings);
  };

  return (
    <div className="pb-6">
      <div className="flex items-center justify-between p-4 ">
        <span className="text-lg text-dark-3 font-IRANSansMedium ">سایر تنظیمات</span>
      </div>
      <Collapse in={appear}>
        <div className="flex flex-col gap-4 p-4">
          {settings.map((item, i) => {
            const a = active.includes(i);
            return (
              <div key={i} className="flex flex-col">
                <div
                  className="flex items-start gap-4 cursor-pointer w-fit"
                  onClick={() => {
                    resetUncheckValue(item.value, !a);
                    a ? setActive((x) => x.filter((x) => x !== i)) : setActive((x) => [...x, i]);
                    handleClick(i, a);
                  }}
                >
                  <Checkbox checked={a} className="h-10" />
                  <div className="w-full ">
                    <span className="flex items-center h-10">{item.label}</span>
                  </div>
                </div>
                <div className="md:pr-14">
                  <Collapse in={a}>
                    <div className="py-6 md:pl-10">
                      <item.comp />
                    </div>
                  </Collapse>
                  <Divider className="my-2 border-slate-300" />
                </div>
              </div>
            );
          })}
        </div>
      </Collapse>
    </div>
  );
}
